import * as tslib_1 from "tslib";
import { ErrorHandler, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MatSnackBar } from '@angular/material';
import { AviationEventsService } from '../../shared/services/aviation-events.service';
import { NgxGalleryOptions, NgxGalleryImage } from 'ngx-gallery';
import { ConfirmationDialogComponent } from '../../shared/confirmation-dialog/confirmation-dialog.component';
import { ImageUploadComponent } from '../../shared/image-upload/image-upload.component';
var EditEventImageComponent = /** @class */ (function () {
    function EditEventImageComponent(_matDialogRef, data, _aviationEventsService, _fb, _snackBar, dialog, _errorHandler) {
        this._matDialogRef = _matDialogRef;
        this._aviationEventsService = _aviationEventsService;
        this._fb = _fb;
        this._snackBar = _snackBar;
        this.dialog = dialog;
        this._errorHandler = _errorHandler;
        this.isBusy = false;
        this.writtenPhotoIds = [];
        this.newPhotoIds = [];
        this.aviationEvent = data.aviationEvent;
        if (this.aviationEvent.photos && this.aviationEvent.photos.length > 0) {
            this._originImage = this.aviationEvent.photos[0];
        }
        else {
            this._originImage = null;
        }
    }
    EditEventImageComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._matDialogRef.backdropClick().subscribe(function () {
            _this._matDialogRef.close(null);
        });
        this.formGroup = this._fb.group({
            coverPhoto: ['', [this.requiredFileType(['jpg', 'png', 'jpeg', 'gif'])]]
        }, { updateOn: 'submit' });
        this.entity = {
            id: this.aviationEvent.eventId,
            name: this.aviationEvent.title,
            type: 'Event'
        };
        this.galleryOptions = [
            {
                width: '341px',
                // height: '255px', // for block with image preview
                height: '80px',
                thumbnailsColumns: 3,
                image: false,
                imageSize: 'contain',
                //  imageAnimation: NgxGalleryAnimation.Slide
                thumbnailsMargin: 5,
                thumbnailMargin: 5,
                imageArrowsAutoHide: true,
                thumbnailsArrowsAutoHide: true
            }
        ];
        if (this.aviationEvent.galleryPhotos) {
            this.galleryImages = this.aviationEvent.galleryPhotos;
        }
        else {
            this.galleryImages = [];
        }
        if (this.aviationEvent.photos) {
            this.aviationEvent.photos.forEach(function (photo) {
                _this.writtenPhotoIds.push(photo.photoId);
            });
        }
        else {
            this.writtenPhotoIds = [];
        }
    };
    EditEventImageComponent.prototype.requiredFileType = function (types) {
        return function (control) {
            var fileName = control.value;
            if (fileName) {
                var extension_1 = fileName.split('.').pop().toLowerCase();
                var hasExtension_1 = false;
                types.forEach(function (it) {
                    if (it.toLowerCase() === extension_1.toLowerCase()) {
                        hasExtension_1 = true;
                        return;
                    }
                });
                if (!hasExtension_1) {
                    return {
                        requiredFileType: true
                    };
                }
            }
        };
    };
    EditEventImageComponent.prototype.deleteImage = function (index) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var dialogRef;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                dialogRef = this.dialog.open(ConfirmationDialogComponent, {
                    width: '350px',
                    data: 'Delete this image?'
                });
                dialogRef.afterClosed().subscribe(function (result) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    var snackBarOpts;
                    return tslib_1.__generator(this, function (_a) {
                        if (result) {
                            snackBarOpts = { duration: 2000 };
                            try {
                                if (index < this.writtenPhotoIds.length) {
                                    this._aviationEventsService.deleteEventCoverImg(this.aviationEvent.eventId, this.writtenPhotoIds[index]);
                                    this.writtenPhotoIds.splice(index, 1);
                                }
                                else {
                                    this.newPhotoIds.splice(index, 1);
                                }
                                this.galleryImages.splice(index, 1);
                            }
                            catch (e) {
                                this._snackBar.open('An error occurred deleting the image. Please try again later.', 'Dismiss', snackBarOpts);
                                this._errorHandler.handleError(e);
                            }
                        }
                        return [2 /*return*/];
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    EditEventImageComponent.prototype.openAddImageDialog = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var dialogRef;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                dialogRef = this.dialog.open(ImageUploadComponent, {
                    width: '500px',
                    data: { images: this.galleryImages, entity: this.entity, newPhotoIds: this.newPhotoIds }
                });
                dialogRef.afterClosed().subscribe(function (result) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    var snackBarOpts;
                    var _this = this;
                    return tslib_1.__generator(this, function (_a) {
                        if (result) {
                            snackBarOpts = { duration: 2000 };
                            try {
                                this.newPhotoIds.forEach(function (photoId) {
                                    if (!_this.writtenPhotoIds.includes(photoId)) {
                                        _this.writtenPhotoIds.push(photoId);
                                    }
                                });
                            }
                            catch (e) {
                                this._snackBar.open('An error occurred deleting the review. Please try again later.', 'Dismiss', snackBarOpts);
                                this._errorHandler.handleError(e);
                            }
                        }
                        return [2 /*return*/];
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    EditEventImageComponent.prototype.cancel = function () {
        if (this._originImage) {
            this.aviationEvent.photos = new Array();
            this.aviationEvent.photos.push(this._originImage);
        }
        else {
            this.aviationEvent.photos = null;
        }
        this._matDialogRef.close(null);
    };
    EditEventImageComponent.prototype.save = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                if (this.formGroup.invalid) {
                    this._snackBar.open('Form field validation failed. check form values', null, { duration: 5000 });
                    return [2 /*return*/];
                }
                try {
                    this.isBusy = true;
                    this.newPhotoIds.forEach(function (photoId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                        var photo;
                        return tslib_1.__generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, this._aviationEventsService.putEventPhoto(this.aviationEvent.eventId, photoId)];
                                case 1:
                                    photo = _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                    this.isBusy = false;
                    this._matDialogRef.close(true);
                }
                catch (e) {
                    this.isBusy = false;
                    this._matDialogRef.close(false);
                }
                return [2 /*return*/];
            });
        });
    };
    return EditEventImageComponent;
}());
export { EditEventImageComponent };
